<template>
    <van-dialog :value="dialogshow" :show-confirm-button="false" :show-cancel-button="false" class="mydialog">
        <div class="tt">
            <div class="p1">必点菜品未点提醒</div>
            <div class="p2">这些菜品不点，可能会影响您享受美餐哦~</div>
        </div>
        <div v-for="item of bidianMenu" class="displayflex row">
            <span class="name">{{item.name}}</span>
            <div class="line">
                <van-button @click="minus(item)">-</van-button>
                <span>{{item.num}}</span>
                <van-button @click="plus(item)">+</van-button>
            </div>
        </div>
        <div class="errormsg" v-if="errormsg">温馨提示：{{errormsg}}</div>

        <div class="btnline displayflex">
            <van-button @click="onCancel" v-if="forceadd==0">不需要</van-button>
            <van-button @click="onSubmit">确认添加</van-button>
        </div>
    </van-dialog>
</template>
<script>
  import Vue from 'vue'
  import 'vant/lib/dialog/style';
  import 'vant/lib/button/style';
  import {Dialog,Button,Toast} from "vant";
  Vue.use(Dialog);
  Vue.use(Button);
  import ServiceUtil from '../../service/ServiceUtils'

  export default {
    name: 'mustdialog',
    props:["show","list","forceadd"],
    data () {
      return {
        dialogshow:false,
        bidianMenu:[],
        errormsg:''
      }
    },
    watch:{
      show(val){
        this.dialogshow = val;
      },
      list(val){
          for(let item of val){
              if(!item.num){
                  item.num = 1;
              }
          }
        this.bidianMenu = val;
      },
    },
    mounted(){
        this.bidianMenu = this.$props.list;
        console.log("mybd,,",this.bidianMenu);
        // list(val){
        // },
    },


    methods:{
      minus(item){
          if(!item.num && item.num!=0) item.num = 1;
          if(item.num==1) return;
          item.num = item.num-1;
          this.errormsg = '';
          this.$forceUpdate();
      },
        plus(item){
            if(!item.num && item.num!=0) item.num = 1;
            item.num = item.num+1;
            this.$forceUpdate();
            this.errormsg = '';
        },
        onCancel(){
            this.$emit('onCancel',false);
            this.dialogshow = false;
        },
        onSubmit(){
           console.log("this.bidianMenu::",this.bidianMenu);
            for(let item of this.bidianMenu){
                if(!item.num){
                    this.errormsg = `${item.name} 为必点项`;
                    return;
                }
            }
            // for(let item of this.bidianMenu) {
            //     item.menuItem = [];
            // }
            this.$emit('onCancel',this.bidianMenu);
            this.dialogshow = false;
        },
    },
  }
</script>
<style scoped lang="scss">
    .mydialog{
        width: 90%;
        border-radius: 0.3rem;
        .tt{
            background: #F9F3E5;
            text-align: center;
            padding: 0.5rem 0;
            border-bottom: 1px solid #e5e5e5;

            .p1{
                font-weight: 600;
              font-size: 1rem;
                color: #333;
            }
            .p2{
                font-size: 0.9rem;
                color: #BE9F5F;
                margin-top: 0.3rem;
            }
        }
        .errormsg{
            padding: 0.5rem;
            font-size: 0.8rem;
            color: #f73833;
            border-bottom: 1px solid #e5e5e5;
        }
        .row{
            padding:0.5rem;
            align-items: center;
            border-bottom: 1px solid #e5e5e5;
        }
        .name{
            flex: 1;
        }
        .line{
            align-items: center;
            .van-button{
                border-radius: 0.2rem;
                background: #BF9E61;
                width: 35px;
                height: 35px;
                line-height: 35px;
                padding: 0;
                text-align: center;
                color: #ffffff;
                font-size: 1.5rem;
                &:first-child{
                    background: #b7b89f;
                }
            }
            span{
                margin: 0 0.5rem;
            }
        }
        .btnline{
            justify-content: space-around;
            padding: 0.7rem 0;
            .van-button{
                color: #fffcf6;
                border-radius: 0.3rem;
                background: #EC432E;

                /*&:nth-child(1){*/
                    /*background: #C19C65;*/
                /*}*/
                /*&:nth-child(2){*/
                    /*background: #EC432E;*/
                /*}*/
            }

        }
    }
    .displayflex{
        display: -moz-box;  /* Firefox */
        display: -ms-flexbox;    /* IE10 */
        display: -webkit-box;    /* Safari */
        display: -webkit-flex;    /* Chrome, WebKit */
        display: box;
        display: flexbox;
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/ordered/mustdialog.vue